export const CodeAction = {
  SHARE: 'share',
  DOWNLOAD: 'download',
  BOOKMARK: 'bookmark',
  PRINT: 'print',
};
